/**
 * Model to map Monitoring Sanction Information Changes.
 *
 * @author mohit.khurana@vernuso.com
 */
export class Sanction {
}



// WEBPACK FOOTER //
// ./src/app/shared/models/sanction.model.ts